// Override Settings
animationCount = 100

var bcSfFilterSettings = {
  general: {
    limit: 15,
  },
}

var soldLabel =
  bcSfFilterConfig.label && bcSfFilterConfig.label.sold_out
    ? bcSfFilterConfig.label.sold_out
    : ''

var saleLabel =
  bcSfFilterConfig.label && bcSfFilterConfig.label.sale
    ? bcSfFilterConfig.label.sale
    : ''

var sortingLabel =
  bcSfFilterConfig.label && bcSfFilterConfig.label.sorting
    ? bcSfFilterConfig.label.sorting
    : ''

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: 'sold-out',
  saleClass: 'on-sale',
  soldOutLabelHtml: '<div>' + soldLabel + '</div>',
  saleLabelHtml: '<div>' + saleLabel + '</div>',
  vendorHtml: '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  productGridItemHtml: `
    <div data-testid="product-grid-item" data-sal="fade" data-sal-duration="800" data-sal-delay="${animationCount}" class="u-w-1/3 s:u-w-1/2 u-py-40 m:u-py-20 u-px-20 m:u-px-10 u-text-center c-product-grid__item c-product-grid--{{itemProductType}}">
      <div class="c-product-grid__inner">
        <a href="{{itemUrl}}" class="c-product-grid__img-wrap" title="">
          <img src="{{itemThumbUrl}}" alt="" class="c-product-grid__img c-product-image--{{itemProductType}} c-product-image--{{itemImageSize}}" />
        </a>

        <div class="u-pt-40">
          <a href="{{itemUrl}}" title="" data-testid="product-grid-item-link" class="c-product-grid__link u-text-12 u-text-primary hover:u-text-copper u-font-400 u-mb-10">
            {{itemTitle}}
          </a>
          <span class="u-text-10 u-text-grey">
            {{itemPrice}}
          </span>
        </div>

      </div>
    </div>
  `,

  // Pagination Template
  previousActiveHtml: '<li><a href="{{itemUrl}}">&lt; Previous</a></li>',
  previousDisabledHtml:
    '<li class="c-pagination--disabled"><span>&lt; Previous</span></li>',
  nextActiveHtml: '<li><a href="{{itemUrl}}">Next &gt;</a></li>',
  nextDisabledHtml:
    '<li class="c-pagination--disabled"><span>Next &gt;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml:
    '<ul class="c-pagination">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  sortingHtml:
    '<label class="label--hidden">' +
    sortingLabel +
    '</label><select class="collection-sort__input">{{sortingItems}}</select>',
}

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
  var slugify = function (text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  var isAvailable = data.available

  /*** Prepare data ***/
  var images = data.images_info
  var soldOut = !data.available // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
  var priceVaries = data.price_min != data.price_max // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0]
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant')
    })
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i]
        break
      }
    }
  }
  /*** End Prepare data ***/

  const filteredGSTCollections = data.collections.filter(function (item) {
    return item.handle === 'no-jersey-gst'
  })

  var productNoGST = false
  if (filteredGSTCollections.length >= 1) {
    var productNoGST = true
  }

  // Select the correct image size based on the product type
  var productType = slugify(data.product_type)

  // set a default image class size and cloudinary transform
  var imageSize = 'default'
  var cloudtransforms = 'h_250,c_limit'

  if (productType === 'necklaces-and-pendants') {
    var cloudtransforms = 'h_200,c_limit'
  }

  if (productType === 'wedding-bands' || productType === 'earrings') {
    var imageSize = 'xlarge'
  }

  if (productType === 'watches') {
    var imageSize = 'large'
    var cloudtransforms = 'h_250,c_limit,e_brightness:5,e_sharpen:100,e_trim:10'
  }

  if (productType === 'rings') {
    var imageSize = 'large'
    var cloudtransforms = 'w_190,c_limit'
  }

  if (productType === 'bracelets') {
    var imageSize = 'small'
    var cloudtransforms = 'h_180,c_limit'
  }

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml

  // Add Thumbnail
  var imagePath = images.length > 0 ? images[0].src.split('?v')[0] : '' // JP: remove the cache query param to avoid caching on replaced assets
  itemThumbUrl =
    images.length > 0
      ? 'https://res.cloudinary.com/diiwppnye/image/fetch/' +
        cloudtransforms +
        '/q_100/' +
        imagePath
      : 'https://cdn.shopify.com/s/files/1/0256/9165/2173/files/placeholder-img_4.png'

  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl)

  // Add Price
  var itemPriceHtml = ''
  if (data.price_min === 0) {
    itemPriceHtml += ''
  } else {
    if (data.title != '') {
      if (productNoGST) {
        itemPriceHtml +=
          '<p class="grid-link__meta"' +
          'data-price="' +
          this.formatMoney(data.price_min) +
          '" data-gst-ignore>'
      } else {
        itemPriceHtml +=
          '<p class="grid-link__meta"' +
          'data-price="' +
          this.formatMoney(data.price_min) +
          '">'
      }

      if (onSale) {
        itemPriceHtml +=
          '<s class="grid-link__sale_price">' +
          this.formatMoney(data.compare_at_price_min) +
          '</s> '
      }
      if (bcSfFilterConfig.label) {
        if (priceVaries) {
          itemPriceHtml += bcSfFilterConfig.label.from_price.replace(
            /{{ price }}/g,
            this.formatMoney(data.price_min)
          )
        } else {
          itemPriceHtml += this.formatMoney(data.price_min)
        }
      }
      itemPriceHtml += '</p>'
    }
  }

  if (!isAvailable || data?.price_min === 0) {
    itemPriceHtml = '<p>POA</p>'
  }

  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml)

  itemHtml = itemHtml.replace(/{{itemImageSize}}/g, imageSize)
  itemHtml = itemHtml.replace(/{{itemProductType}}/g, productType)

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : ''
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : ''
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : ''
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml)

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : ''
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml)

  // Add Vendor
  var itemVendorHtml =
    bcSfFilterConfig.custom && bcSfFilterConfig.custom.vendor_enable
      ? bcSfFilterTemplate.vendorHtml.replace(
          /{{itemVendorLabel}}/g,
          data.vendor
        )
      : ''
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml)

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data))

  return itemHtml
}

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
}

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    var currentPage = parseInt(this.queryParams.page)
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit)

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('')
      return false
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? bcSfFilterTemplate.previousActiveHtml
          : bcSfFilterTemplate.previousDisabledHtml
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink('page', currentPage, currentPage - 1)
      )
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? bcSfFilterTemplate.nextActiveHtml
          : bcSfFilterTemplate.nextDisabledHtml
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink('page', currentPage, currentPage + 1)
      )
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)

      // Create page items array
      var beforeCurrentPageArr = []
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore)
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...')
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1)
      }
      beforeCurrentPageArr.push(currentPage)

      var afterCurrentPageArr = []
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter)
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...')
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage)
      }

      // Build page items
      var pageItemsHtml = ''
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? bcSfFilterTemplate.pageItemSelectedHtml
              : bcSfFilterTemplate.pageItemHtml
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          this.buildToolbarLink('page', currentPage, pageArr[iPage])
        )

        animationCount += 300
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)

      jQ(this.selector.bottomPagination).html(paginationHtml)
    }
  }

  // restart animations
  if (window.sal) {
    window.sal()
  }

  // rebuild prices based on the currency switcher
  if (window.switcher) {
    window.switcher()
  }
}

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('')

    var sortingArr = this.getSortingList()
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = ''
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + '</option>'
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      )
      jQ(this.selector.topSorting).html(html)

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort)
    }
  }

  // restart animations
  if (window.sal) {
    window.sal()
  }

  // rebuild prices based on the currency switcher
  if (window.switcher) {
    window.switcher()
  }
}

BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml =
    '<a href="' +
    this.buildToolbarLink('display', 'list', 'grid') +
    '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>'
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'grid', 'list') +
    '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>'
  jQ(this.selector.topDisplayType).html(itemHtml)

  // Active current display type
  jQ(this.selector.topDisplayType)
    .find('.bc-sf-filter-display-list')
    .removeClass('active')
  jQ(this.selector.topDisplayType)
    .find('.bc-sf-filter-display-grid')
    .removeClass('active')
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType)
      .find('.bc-sf-filter-display-list')
      .addClass('active')
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType)
      .find('.bc-sf-filter-display-grid')
      .addClass('active')
  }
}

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a, b) {
  var c = window.location.href.split('?')[0]
  return (c += '?' + a + '=' + b)
}
BCSfFilter.prototype.buildDefaultElements = function (a) {
  if (
    bcSfFilterConfig.general.hasOwnProperty('collection_count') &&
    jQ('#bc-sf-filter-bottom-pagination').length > 0
  ) {
    var b = bcSfFilterConfig.general.collection_count,
      c = parseInt(this.queryParams.page),
      d = Math.ceil(b / this.queryParams.limit)
    if (1 == d) return jQ(this.selector.pagination).html(''), !1
    if ('default' == this.getSettingValue('general.paginationType')) {
      var e = bcSfFilterTemplate.paginateHtml,
        f = ''
      ;(f =
        c > 1
          ? bcSfFilterTemplate.hasOwnProperty('previousActiveHtml')
            ? bcSfFilterTemplate.previousActiveHtml
            : bcSfFilterTemplate.previousHtml
          : bcSfFilterTemplate.hasOwnProperty('previousDisabledHtml')
          ? bcSfFilterTemplate.previousDisabledHtml
          : ''),
        (f = f.replace(/{{itemUrl}}/g, buildDefaultLink('page', c - 1))),
        (e = e.replace(/{{previous}}/g, f))
      var g = ''
      ;(g =
        c < d
          ? bcSfFilterTemplate.hasOwnProperty('nextActiveHtml')
            ? bcSfFilterTemplate.nextActiveHtml
            : bcSfFilterTemplate.nextHtml
          : bcSfFilterTemplate.hasOwnProperty('nextDisabledHtml')
          ? bcSfFilterTemplate.nextDisabledHtml
          : ''),
        (g = g.replace(/{{itemUrl}}/g, buildDefaultLink('page', c + 1))),
        (e = e.replace(/{{next}}/g, g))
      for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i)
      c - 4 > 0 && h.unshift('...'), c - 4 >= 0 && h.unshift(1), h.push(c)
      for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k)
      c + 3 < d && j.push('...'), c + 3 <= d && j.push(d)
      for (var l = '', m = h.concat(j), n = 0; n < m.length; n++)
        '...' == m[n]
          ? (l += bcSfFilterTemplate.pageItemRemainHtml)
          : (l +=
              m[n] == c
                ? bcSfFilterTemplate.pageItemSelectedHtml
                : bcSfFilterTemplate.pageItemHtml),
          (l = l.replace(/{{itemTitle}}/g, m[n])),
          (l = l.replace(/{{itemUrl}}/g, buildDefaultLink('page', m[n])))
      ;(e = e.replace(/{{pageItems}}/g, l)),
        jQ(this.selector.pagination).html(e)
    }
  }
  if (
    bcSfFilterTemplate.hasOwnProperty('sortingHtml') &&
    jQ(this.selector.topSorting).length > 0
  ) {
    jQ(this.selector.topSorting).html('')
    var o = this.getSortingList()
    if (o) {
      var p = ''
      for (var q in o) p += '<option value="' + q + '">' + o[q] + '</option>'
      var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p)
      jQ(this.selector.topSorting).html(r)
      var s =
        void 0 !== this.queryParams.sort_by
          ? this.queryParams.sort_by
          : this.defaultSorting
      jQ(this.selector.topSorting + ' select').val(s),
        jQ(this.selector.topSorting + ' select').change(function (a) {
          window.location.href = buildDefaultLink('sort_by', jQ(this).val())
        })
    }
  }
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
  for (var k = 0; k < data.length; k++) {
    data[k]['images'] = data[k]['images_info']
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0]
    } else {
      data[k]['featured_image'] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: '',
        height: '',
        aspect_ratio: 0,
      }
    }
    data[k]['url'] = '/products/' + data[k].handle
    var optionsArr = []
    for (var i = 0; i < data[k]['options_with_values'].length; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name'])
    }
    data[k]['options'] = optionsArr
    ;(data[k]['price_min'] *= 100),
      (data[k]['price_max'] *= 100),
      (data[k]['compare_at_price_min'] *= 100),
      (data[k]['compare_at_price_max'] *= 100)
    data[k]['price'] = data[k]['price_min']
    data[k]['compare_at_price'] = data[k]['compare_at_price_min']
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']
    var firstVariant = data[k]['variants'][0]
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      for (var i = 0; i < data[k]['variants'].length; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i]
          break
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant
    for (var i = 0; i < data[k]['variants'].length; i++) {
      var variantOptionArr = []
      var count = 1
      var variant = data[k]['variants'][i]
      var variantOptions = variant['merged_options']
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(':')
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]
          data[k]['variants'][i]['option_' + temp[0]] = temp[1]
          variantOptionArr.push(temp[1])
        }
        data[k]['variants'][i]['options'] = variantOptionArr
      }
      data[k]['variants'][i]['compare_at_price'] =
        parseFloat(data[k]['variants'][i]['compare_at_price']) * 100
      data[k]['variants'][i]['price'] =
        parseFloat(data[k]['variants'][i]['price']) * 100
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html']
  }
  return data
}

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {}

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {}
